import { styled } from 'styled-components';

import devices from '../../styles/devices';

/**
 * Feed empty state,
 * Showing an illustration that the topic is empty
 */
export const EmptyStateWrapper = styled.div`
  align-items: center;
  display: flex;
  height: var(--height-full);
  justify-content: center;
  width: 100%;

  /* Since our feed has height to fit-content, in order, adding some
  height to empty state container so that empty state would be in the middle of the page. */
  @media ${devices.tabletS} {
    height: 70vh;
  }
`;
